import React, { LabelHTMLAttributes } from 'react';
import { LabelStyled } from './LabelBold.styles';

interface ILabelBold extends LabelHTMLAttributes<any> {
  className?: string;
  children: React.ReactNode;
}

const LabelBold = ({ className, children, ...labelProps }: ILabelBold) => {
  return (
    <LabelStyled className={className} {...labelProps}>
      {children}
    </LabelStyled>
  );
};

export default LabelBold;
